import { createContext } from "react";

interface AuthContextInterface {
    token: string|null;
    setToken: (token: string) => void;
}

export const AuthContext = createContext<AuthContextInterface>({
    token: null,
    setToken: () => {},
});